import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isDisabled", "id", "value", "menuPlacement", "variant", "onChange", "neutralOption"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { getLanguageList } from 'i18n/options';
import useUniqueId from 'hooks/useUniqueId';
import { getTypedSelectComponents, OptionsDivider } from 'components/Select';
import FormField from 'components/FormField';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var _getTypedSelectCompon = getTypedSelectComponents(),
  Select = _getTypedSelectCompon.Select,
  Option = _getTypedSelectCompon.Option;
var LanguageField = function LanguageField(_ref) {
  var isDisabled = _ref.isDisabled,
    id = _ref.id,
    value = _ref.value,
    _ref$menuPlacement = _ref.menuPlacement,
    menuPlacement = _ref$menuPlacement === void 0 ? 'top' : _ref$menuPlacement,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'transparent' : _ref$variant,
    onChange = _ref.onChange,
    _ref$neutralOption = _ref.neutralOption,
    neutralOption = _ref$neutralOption === void 0 ? 'select' : _ref$neutralOption,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var uniqueId = useUniqueId(id);
  var languageList = getLanguageList();
  function changeLanguage(newLocale) {
    onChange(newLocale === 'auto' ? null : newLocale);
  }
  return /*#__PURE__*/_jsx(FormField, _objectSpread(_objectSpread({
    as: "span",
    label: t('form_language'),
    labelId: uniqueId
  }, otherProps), {}, {
    children: /*#__PURE__*/_jsxs(Select, {
      icon: "globe",
      labelledById: uniqueId,
      size: "medium",
      variant: variant,
      menuPlacement: menuPlacement,
      value: value || 'auto',
      onChange: changeLanguage,
      ml: variant === 'transparent' ? '-xxs' : 0,
      isDisabled: isDisabled,
      children: [neutralOption === 'auto' && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Option, {
          value: "auto",
          children: t('language_auto')
        }), /*#__PURE__*/_jsx(OptionsDivider, {})]
      }), neutralOption === 'select' && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Option, {
          value: "auto",
          children: t('actions_select_language')
        }), /*#__PURE__*/_jsx(OptionsDivider, {})]
      }), languageList.map(function (value) {
        return /*#__PURE__*/_jsx(Option, {
          value: value.value,
          children: value.title
        }, value.value);
      })]
    })
  }));
};
export default LanguageField;